module.exports = __webpack_public_path__ + "static/media/printer.61463f9f.jpg";